<template>
  <div class="company-detail-bd">
    <div class="company-header" v-if="formList">
      <i class="icon icon-fanhuijiantou" @click="jump($route.query.parentPath)" style="cursor: pointer"></i>
      <span class="company-name">{{ data.partnerName }}</span>
    </div>
    <div class="company-msg" v-else>
      <div class="logo-content"></div>
      <div class="msg-content">
        <div class="company-name">{{ data.partnerName }}</div>
        <div class="detail-content">
          <div class="item">
            <div class="key">{{$t('crm_renter_detail.zhgly')}}</div>
            <div class="val">
              <span class="name">{{ adminMsg.loginName }}</span>
              <span class="phone">{{ adminMsg.mobile }}</span>
              <span class="replace" @click="replace" v-if="propsFuncView.company_change_manager ">
              {{propsFuncView.company_change_manager }}
              </span>
            </div>
          </div>
          <div class="item">
            <div class="key">{{$t('crm_renter_detail.ren_zheng_zhuang_tai')}}</div>
            <div class="val">
              <span
                class="status"
                v-if="
                  getDicValue(
                    'real_auth_status',
                    data.realNameState
                  )
                "
                >{{
                  getDicValue(
                    "real_auth_status",
                    data.realNameState
                  )
                }}</span
              >
              <span class="auth" @click="identification" v-if="showAuth && propsFuncView.company_certification">{{
                propsFuncView.company_certification
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-content">
      <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
      <div class="tab-content">
        <!-- 基本信息 -->
        <detail-base
          v-if="tabIndex === 0 && (enterpriseType===1 || enterpriseType===2)&&!pageFuncView.partner_renter_simple"
          :partnerId="renterId"
          :data="data"
        ></detail-base>
        <!-- 单位基本信息 -->
        <detail-base-institutions
          v-if="tabIndex === 0 && enterpriseType===3&&!pageFuncView.partner_renter_simple"
          :partnerId="renterId"
          :data="data"
        ></detail-base-institutions>
        <!-- 宗教基本信息 -->
        <detail-base-religion
          v-if="tabIndex === 0 && enterpriseType===4&&!pageFuncView.partner_renter_simple"
          :partnerId="renterId"
          :data="data"
        ></detail-base-religion>
        <!-- 个人租赁方 -->
        <detail-base-personal
          v-if="tabIndex === 0 && enterpriseType===5&&!pageFuncView.partner_renter_simple"
          :partnerId="renterId"
          :data="data"
        ></detail-base-personal>
        <!-- 美国简版 -->
         <detail-base-us
          v-if="tabIndex === 0&&pageFuncView.partner_renter_simple"
          :partnerId="companyId"
          :data="data"
        ></detail-base-us>
        <!-- 联络人 -->
        <partner-contact
          v-if="tabIndex === 1"
          :partnerOrgId="partnerOrgId"
          :partnerId="renterId"
          :data="data"
        >
        </partner-contact>
        <!-- 业务员 -->
        <partner-salesman
          v-if="tabIndex === 14"
          :partnerId="factoryId"
          :partnerOrgId="partnerOrgId"
          :data="data"
        >
        </partner-salesman>
         <!-- 合同 -->
        <partner-contract
          v-if="tabIndex === 2"
          :partnerOrgId="partnerOrgId"
          :partnerId="renterId"
          :partnerType="partnerType"
          bizType="service"
          class="contract"
        ></partner-contract>
        <!-- 设备 -->
        <partner-device
          v-if="tabIndex === 3"
          :partnerOrgId="partnerOrgId"
          partnerType='CS'
          class="device"
        ></partner-device>

        <partner-bankCard
          v-if="tabIndex === 4"
          :partnerOrgId="partnerOrgId"
          :partnerId="renterId"
          :partnerType="partnerType"
        >
        </partner-bankCard>
        <!--实名证书 -->
        <partner-cert
          v-if="tabIndex === 5"
          :data="data"
          class="cert"
        ></partner-cert>
        <!-- 用户管理 -->
        <user-manage v-if="tabIndex === 10" :orgId="partnerOrgId" orgBy="renter"></user-manage>
        <!-- 部门管理 -->
        <department-manage v-if="tabIndex === 11" :orgId="partnerOrgId"></department-manage>
        <!-- 设备分配 -->
        <organdevice-manage v-if="tabIndex === 12" :orgId="partnerOrgId"></organdevice-manage>
        <!-- 岗位管理 -->
        <role-manage v-if="tabIndex === 13" :orgId="partnerOrgId"></role-manage>
      </div>
    </div>
    <!-- 跟换管理员-->
    <company-administrators-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :data="dialogData"
      @close="dialogVisible = false"
      @success="getAdministrators"
    ></company-administrators-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partnerContract from '@/pages/crm/components/partnerCommon/partner-contract.vue';
import partnerDevice from '@/pages/crm/components/partnerCommon/partner-device.vue';
import partnerBankCard from '@/pages/crm/components/partnerCommon/partner-bankCard.vue';
import partnerCert from '@/pages/crm/components/partnerCommon/partner-cert.vue';
import detailBaseInstitutions from '@/pages/crm/components/partnerCommon/partner_detail_base_institutions.vue';
import detailBaseReligion from '@/pages/crm/components/partnerCommon/partner_detail_base_religion.vue';
import companyAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog.vue';
import detailBaseUs from '@/pages/crm/components/partnerCommon/partner_detail_base_us.vue';
import userManage from '@/pages/base/user/user.vue';
import departmentManage from '@/pages/base/department/department.vue';
import organdeviceManage from '@/pages/base/organdevice/organdevice.vue';
import roleManage from '@/pages/base/role/role.vue';
import partnerSalesman from '@/pages/crm/components/partnerCommon/partner-salesman';
import partnerContact from './renter_detail_contact.vue';
import detailBase from './renter_detail_base.vue';
import detailBasePersonal from './partner_detail_base_personal.vue';

export default {
  components: {
    userManage,
    departmentManage,
    organdeviceManage,
    roleManage,
    // companyContactsDialog,
    partnerContract,
    partnerDevice,
    partnerBankCard,
    detailBase,
    detailBaseUs,
    partnerContact,
    detailBaseInstitutions,
    detailBaseReligion,
    partnerCert,
    detailBasePersonal,
    companyAdministratorsDialog,
    partnerSalesman
    // imgDetailDialog
  },
  props: {
    propsFuncView: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      tabIndex: null,
      activeName: 'information',
      renterId: '',
      // 管理员信息
      adminList: [],
      data: {},
      // 管理员ID
      partnerOrgId: '',
      partnerType: '',
      administratorsData: [],
      // 联系人
      contactList: [],
      equipmentSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        // pageSize: 40,
        // pageNum: 1,
        bizId: '', //
        isAss: 1 // 是否关联0：未关联 1关联
      },

      // 更换管理员
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      // 联系人组ID用户新增联系人
      bizId: '',
      // 图片预览
      dialogImageUrl: '',
      dialogVisible1: false,

      // 租赁方表格
      tableCode: 'service_hire',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // partnerType: 'SC', // 售后公司service
        partnerId: '',
        businessLicense: ''
      },
      totalRows: null,
      isLoading: false,
      tenterList: [],
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      companyItem: [],
      // 公司类型
      enterpriseType: '',
      pageFuncView: {}
    };
  },
  computed: {
    adminMsg() {
      if (this.administratorsData && this.administratorsData.length) {
        const admin = this.administratorsData[0];
        return admin;
      }
      return {};
    },
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    },
    tabData() {
      const companyMsg = {
        name: this.$t('crm_renter_detail.gong_si_xin_xi'),
        value: 0
      };
      const contactPerson = {
        name: this.$t('crm_renter_detail.lian_luo_ren'),
        value: 1
      };
      const contentSalesman = {
        name: this.$t('crm_renter_detail.ye_wu_yuan'),
        value: 14
      };
      const contract = {
        name: this.$t('crm_renter_detail.he_tong'),
        value: 2
      };

      const device = {
        name: this.$t('crm_renter_detail.she_bei'),
        value: 3
      };

      const card = {
        name: this.$t('crm_renter_detail.yin_hang_ka'),
        value: 4
      };
      const cert = {
        name: this.$t('crm_renter_detail.shi_ming_zheng_shu'),
        value: 5
      };
      // 2022-04-12  JV_SC JV 合同 设备  不显示
      const user = {
        name: this.$t('crm_renter_detail.yong_hu_guan_li'),
        value: 10,
      };
      const department = {
        name: this.$t('crm_renter_detail.bu_men_guan_li'),
        value: 11,
      };
      const organdevice = {
        name: this.$t('crm_renter_detail.she_bei_fen_pei'),
        value: 12,
      };
      const role = {
        name: this.$t('crm_renter_detail.gang_wei_guan_li'),
        value: 13,
      };
      // // enterpriseType 5 个人租赁方
      // if (this.formList && this.enterpriseType === 5 && !!this.data.certNo) {
      //   // 临时加的
      //   if (this.bizType === 'JV' || this.bizType === 'JV_SC') {
      //     // 个人租赁方
      //     return [companyMsg, card, cert, user, department, organdevice, role];
      //   }
      //   // 个人租赁方
      //   return [companyMsg, device, card, cert, user, department, organdevice, role];

      // } else if (this.formList && this.enterpriseType === 5 && !this.data.certNo) {
      //   // 临时加的
      //   if (this.bizType === 'JV' || this.bizType === 'JV_SC') {
      //     return [companyMsg, user, department, organdevice, role];
      //   }
      //   return [companyMsg, device, card, user, department, organdevice, role];
      // }
      // if (this.formList && this.enterpriseType !== 5 && !!this.data.certNo) {
      //   // 临时加的
      //   if (this.bizType === 'JV' || this.bizType === 'JV_SC') {
      //     return [companyMsg, contactPerson, card, cert, user, department, organdevice, role];
      //   }
      //   return [companyMsg, contactPerson, contract, device, card, cert, user, department, organdevice, role];
      // } else if (this.formList && this.enterpriseType !== 5 && !this.data.certNo) {
      //   // 临时加的
      //   if (this.bizType === 'JV' || this.bizType === 'JV_SC') {
      //     return [companyMsg, contactPerson, card, user, department, organdevice, role];
      //   }
      //   return [companyMsg, contactPerson, contract, device, card, user, department, organdevice, role];
      // } else if (this.data.certNo) {
      //   return [companyMsg, contactPerson, card, cert, user, department, organdevice, role];
      // }
      // return [companyMsg, contactPerson, card, user, department, organdevice, role];
      const arr = [];
      // 美国简版
      if (this.pageFuncView.partner_renter_simple) {
        if (this.funcView.partner_detail_msg || this.propsFuncView.base_info) {
          arr.push(companyMsg);
        }
        if (this.funcView.partner_detail_person || this.propsFuncView.company_person) {
          arr.push(contactPerson);
        }
        if (this.propsFuncView.company_salesman) {
          arr.push(contentSalesman);
        }
        if (this.funcView.partner_detail_user) {
          arr.push(user);
        }
        if (this.funcView.partner_detail_department) {
          arr.push(department);
        }
        if (this.funcView.partner_detail_organdevice) {
          arr.push(organdevice);
        }
        if (this.funcView.partner_detail_role) {
          arr.push(role);
        }

      } else {
        // 中国版
        if (this.funcView.partner_detail_msg || this.propsFuncView.base_info) {
          arr.push(companyMsg);
        }
        if ((this.funcView.partner_detail_person || this.propsFuncView.company_person) && this.enterpriseType !== 5) {
          arr.push(contactPerson);
        }
        if (this.propsFuncView.company_salesman) {
          arr.push(contentSalesman);
        }
        if (this.funcView.partner_detail_contract && this.enterpriseType !== 5) {
          arr.push(contract);
        }
        if (this.funcView.partner_detail_device && this.enterpriseType !== 5) {
          arr.push(device);
        }
        if (this.funcView.partner_detail_card) {
          arr.push(card);
        }
        if (this.funcView.partner_detail_cert && this.data.certNo) {
          arr.push(cert);
        }
        if (this.funcView.partner_detail_user) {
          arr.push(user);
        }
        if (this.funcView.partner_detail_department) {
          arr.push(department);
        }
        if (this.funcView.partner_detail_organdevice) {
          arr.push(organdevice);
        }
        if (this.funcView.partner_detail_role) {
          arr.push(role);
        }
      }
      return arr;
    },
    // 是否来自列表页
    formList() {
      return !!this.getJump('renterId');
    },
    // 是否去认证
    showAuth() {
      return (
        this.data.realNameState === undefined
        || ['0', '3'].includes(`${this.data.realNameState}`)
      );
    }
  },
  watch: {
    tabData: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          if (!this.tabIndex && this.partnerOrgId) {
            const tabCode = this.getJump('tab');
            this.tabIndex = tabCode === 'user' ? 10 : val[0].value;
          }
        }
      },
    },
  },
  mounted() {
    this.renterId = this.getJump('renterId');
    this.getDictionary(
      'crm_partner_biz_type,crm_partner_scale,isynergy_cloud_currency'
    );
    // 获取详情
    this.getCompanyDetail();
    this.getFuncView('/customer/renter', (res) => {
      this.pageFuncView = res;
      this.getFuncView();
    });
    // this.getFuncView('/customer/renterDetail');
  },
  methods: {
    identification() {
      // 个人租赁方只能手机号认证 type: 'single'
      if (this.data.enterpriseType === 5) {
        this.$router.push({
          path: '/identification',
          query: {
            partnerId: this.renterId,
            type: 'single'
          }
        });
      } else {
        this.$router.push({
          path: '/identification',
          query: {
            partnerId: this.renterId
          }
        });
      }

    },
    replace() {
      const oldAdmin = {};
      // 设置值与列表上的字段一样
      oldAdmin.adminLoginName = this.adminMsg.loginName;
      oldAdmin.adminName = this.adminMsg.realName;
      oldAdmin.adminId = this.adminMsg.userId;
      oldAdmin.partnerOrgId = this.adminMsg.orgId;
      this.dialogData = Object.assign(this.data, oldAdmin);
      this.dialogModel.title = this.$t('crm_renter_detail.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    // 初始化
    init: function () {
      this.detail = {};
      this.modelDetail = {};
      this.getProductDetail();
    },


    // 获取售后公司详情
    getCompanyDetail: function () {
      return this.$getJSON(apis.partnerInfo, {
        partnerId: this.renterId
      }).then((res) => {
        if (res.code === 0) {
          this.data = res.data;
          this.renterId = this.data.partnerId;
          // 公司类型
          this.partnerOrgId = res.data.partnerOrgId;
          this.partnerType = res.data.partnerType;
          this.equipmentSearch.bizId = res.data.partnerOrgId;
          // 租赁方ID
          this.formSearch.partnerId = this.renterId;
          // 公司类型
          this.enterpriseType = res.data.enterpriseType;
          // 管理员
          this.getAdministrators();
          // 联系人
          // this.getPartnerContact();
          // 设备
          // this.getEquipment();
          // 租赁方
          // this.getTenter();
          if (!this.tabIndex) {
            const tabCode = this.getJump('tab');
            if (tabCode === 'user') {
              this.tabIndex = 10;
            } else if (this.tabData && this.tabData.length) {
              this.tabIndex = this.tabData[0].value;
            }
          }
        }
      });
    },
    // 管理员
    getAdministrators() {
      this.$getJSON(`${apis.partnerOrganAdminItem}/${this.partnerOrgId}`).then(
        (res) => {
          if (res.code === 0) {
            res.data = res.data || {};
            if (JSON.stringify(res.data) === '{}') {
              this.administratorsData = [];
            } else {
              this.administratorsData.push(res.data);
            }
          }
        }
      );
    },
    // 联系人
    getPartnerContact() {
      this.$getJSON(apis.partnerContact, {
        partnerId: this.renterId
      }).then((res) => {
        if (res.code === 0) {
          this.contactList = res.data;
          // 定义联系人的组织id 暂时
        }
      });
    },
    // 设备
    // getEquipment() {
    //   this.$getJSON(apis.DeviceBizPage, this.equipmentSearch).then((res) => {
    //     if (res.code === 0) {
    //     }
    //   });
    // },
    getTenterList: function () {
      this.$getJSON(apis.partnerCustomerPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          // 租赁方
          this.tenterList = res.data.list;
          this.totalRows = res.data.total;
        }
      });
    },
    // 删除表格列
    // deleteCompany: function ({ partnerId }) {
    //   this.$confirm('你确定要删除当前售后公司吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       this.$postJSON(`${apis.partnerDelete}/${partnerId}`).then((res) => {
    //         if (res.code === 0) {
    //           this.$message({
    //             message: '删除售后公司成功',
    //             type: 'success'
    //           });
    //           this.getCompanyList();
    //         }
    //       });
    //     })
    //     .catch(() => {});
    // },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getTenterList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getTenterList();
    },


    DeleteContact(contactId) {
      this.$showConfirm(this.$t('crm_renter_detail.sfscsxx'))
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`).then(
            (res) => {
              if (res.code === 0) {
                this.$message({
                  message: this.$t('Common.com_delete_success'),
                  type: 'success'
                });
                this.getPartnerContact();
              }
            }
          );
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../style/colors.scss";
.company-detail-bd {
  position: relative;
  padding: 16px;

  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .company-header {
    line-height: 32px;
    padding: 24px 0;
    background:rgba(228,235,242,1);
    .icon {
      font-size: 16px;
      font-weight: bold;
    }
    .company-name {
      font-size: 18px;
      color: #394668;
      font-weight: bold;
      padding-left: 9px;
    }
  }

  .company-msg {
    height: 134px;
    background: #fff;
    margin-top: 16px;
    margin-bottom: 16px;
    flex-shrink: 0;
    .logo-content {
      $r: 40px;
      width: $r;
      height: $r;
      float: left;
      background: #0d9ae0;
      margin-left: 24px;
      margin-top: 24px;
      background-size: 24px 24px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("~@/images/layout/icon_company.png");
      border-radius: 4px;
    }
    .msg-content {
      float: left;
      margin-left: 24px;

      .company-name {
        line-height: 22px;
        font-size: 16px;
        font-weight: bold;
        margin-top: 24px;
      }

      .detail-content {
        overflow: hidden;

        margin-top: 24px;
        .item {
          float: left;
          min-width: 214px;
          font-size: 12px;
          line-height: 16px;
          margin-right: 16px;
          .key {
            color: #98a6ad;
          }
          .val {
            margin-top: 8px;
            color: #495057;
            font-weight: bold;

            > span {
              display: inline-block;
            }

            .phone {
              margin-left: 8px;
            }
            .replace{
              margin-left: 20px;
              cursor: pointer;
              color: #0d9ae0;
              text-decoration: underline;
            }
            .auth {
              margin-left: 20px;
              cursor: pointer;
              color: #0d9ae0;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  .company-content {
    // min-height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: auto;
    .tab-content {
      flex: 1;
      overflow: auto;
      height: 0;
      .contract {
        /deep/ .management-wrap {
          height: auto;
          margin-top: 0;
        }
      }

      .device {
        padding: 0;
        /deep/ .product-wrap {
          height: auto;
          margin-top: 0;
        }
      }
    }
    .information {
      .tenter-body {
        height: 500px;
        background-color: #fff;
        padding: 0px 10px 0;
        border: 1px solid #e4e4e4;
        margin-bottom: 90px;
        p {
          color: #262626;
          height: 24px;
          margin-bottom: 20px;
          font-weight: bold;
          line-height: 24px;
          font-size: 16px;
        }
      }
    }

    .liaison {
      padding: 16px 16px 0 16px;
      .liaison-body {
        padding: 30px 0 60px 40px;
        background-color: #fff;
        display: flex;
        ul {
          display: flex;
          flex-flow: wrap;
          li.card {
            margin: 0 20px 20px 0;
            height: 155px;
            width: 300px;
            background-color: #fff;
            padding: 20px 0 0 20px;
            position: relative;
            border: 1px solid rgba(228, 228, 228, 1);
            h3 {
              color: #262626;
              height: 24px;
              line-height: 1;
              margin-bottom: 18px;
            }
            p {
              font-size: 14px;
              line-height: 20px;
              margin-bottom: 6px;
            }
            .operation {
              position: absolute;
              right: 20px;
              bottom: 15px;
              color: $main-color;
              span {
                margin-left: 20px;
                font-size: 12px;
              }
            }
          }
          .add-liaison {
            width: 155px;
            height: 155px;
            font-size: 50px;
            line-height: 155px;
            text-align: center;
            color: #e4e4e4;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(228, 228, 228, 1);
          }
        }
      }
    }
    .tenter {
      padding: 16px 16px 0 16px;
    }
  }
}
</style>
